import * as React from 'react';
import EyecatchImg from './images/careerchange_ survey-popup.jpg';
import './careerChangeSurveyNotificationPane.module.scss';
import { LazyImage } from '../../../../../commonv3/components/atoms/images/LazyImage';
import { Button } from '../../../../../commonv3/components/atoms/buttons/Button';
import { V3Routes } from '../../../../routes';
import { SurveyKeys } from '../../../../../commonv3/types/surveys';

export class CareerChangeSurveyNotificationPane extends React.Component {
    render() {
        return (
            <div styleName="pane">
                <LazyImage src={EyecatchImg} styleName="eye-catch" offset={0} />
                <div styleName="description">
                    SHElikesの学びを生かして<br />
                    何らかのキャリアチェンジをされた方に<br />
                    アンケートへの回答をお願いしております。
                </div>
                <div styleName="footer">
                    <Button type="primary" size="m" to={V3Routes.survey(SurveyKeys.CAREER_CHANGE)}>
                        今すぐ回答する
                    </Button>
                </div>
            </div>
        );
    }
}
